import { Button, DatePicker, Form, Input,  Table } from "antd"
import { searchDonation } from "../../api"
import {  PageBuilder } from "../../utils/Page"
import { useEffect, useState } from "react"
import '../matchResult/index.css'
import { DonationSearchFilter, DonationView } from "../../interfaces/Donation"
import { format } from 'date-fns';

const Donation = () => {
    const [searchFilter, setSearchFilter] = useState<DonationSearchFilter>({})
    const [data, setData] = useState<DonationView[]>()
    const [current, setCurrent] = useState<number>(1)
    const [pageSize, setPageSize] = useState<number>(10)
    const [totalElements, setTotalElements] = useState<number>(500)
    const columns = [
        {
            title: "ID",
            dataIndex: "id",
        },
        {
            title: "用户编号",
            dataIndex: "userNumber",
        },
        {
            title:"订单编号",
            dataIndex:"serial"
        },
        {
            title: "金额",
            dataIndex: "amount",
        },
        {
            title: "申请时间",
            dataIndex: "applicationTime",
           render: (time?: Date) => time?format(time, 'yyyy-MM-dd'):''
        },
        {
            title: "匹配时间",
            dataIndex: "matchTime",
           render: (time?: Date) => time?format(time, 'yyyy-MM-dd'):''
        },
        {
            title: "预付款",
            dataIndex: "prePayment",
        },
    ]

    const search = async () => {
        const page = new PageBuilder()
            .setPage(current - 1)
            .setSize(pageSize)
            .build()
        const { data } = await searchDonation({
            params: { ...page, searchFilterCombineOperation: "AND" },
            filters: searchFilter
        })
        setData(data.content)
        setTotalElements(data.totalElements)
    }

    const handleSearch = async (filter: DonationSearchFilter) => {
        setSearchFilter(filter)
    }

    const handleTableChange = (pagination: any) => {
        setCurrent(pagination.current)
        setPageSize(pagination.pageSize)
    }

    useEffect(() => { search() }, [current, pageSize, searchFilter])
    return <div>
        <div className="flex-box">
            <Form<DonationSearchFilter>
                layout="inline"
                onFinish={handleSearch}
            >
                <Form.Item 
                label="手机号: "
                name="phoneNumberLike">
                    <Input />
                </Form.Item>
                <Form.Item
                    label="订单编号: "
                    name="serial"
                    >
                    <Input type="number"/>
                </Form.Item>
                <Form.Item
                    label="金额: "
                    name="amount"
                    >
                    <Input type="number"/>
                </Form.Item>
              <Form.Item
                label="申请开始时间: "
                name="applicationTimeAfter">
                <DatePicker />
              </Form.Item>
                <Form.Item
                    label="申请结束时间: "
                    name="applicationTimeBefore"
                    >
                <DatePicker />
                </Form.Item>
                <Form.Item
                label="匹配开始时间: "
                name="matchTimeAfter">
                <DatePicker />
              </Form.Item>
                <Form.Item
                    label="匹配结束时间: "
                    name="matchTimeBefore"
                    >
                <DatePicker />
                </Form.Item>
                <div className="search-button">
                <Form.Item>
                    <Button htmlType="reset" type="default">重置</Button>
                </Form.Item>
                <Form.Item>
                    <Button htmlType="submit" type="primary">搜索</Button>
                </Form.Item>
                </div>
            </Form>
        </div>

        <Table<DonationView> rowKey={'id'} columns={columns} dataSource={data}
            pagination={{
                current: current,
                total: totalElements,
                hideOnSinglePage: true
            }}
            onChange={handleTableChange}
        />
    </div>
}

export default Donation
